import styles from './RichTextMain.module.scss';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export default function RichTextMain({ fields }) {
  return (
    <div className={styles.main}>
      <div className="container">
        <div className={styles.inner}>
          <RichText field={fields.content}></RichText>
        </div>
      </div>
    </div>
  );
}
